import { render } from "./AssetsDashboard.vue?vue&type=template&id=30544180&scoped=true&ts=true"
import script from "./AssetsDashboard.vue?vue&type=script&lang=ts"
export * from "./AssetsDashboard.vue?vue&type=script&lang=ts"

import "./AssetsDashboard.vue?vue&type=style&index=0&id=30544180&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30544180"]])

export default __exports__